"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var isStateAwaitingNavigatorMount_exports = {};
__export(isStateAwaitingNavigatorMount_exports, {
  isStateAwaitingNavigatorMount: () => isStateAwaitingNavigatorMount
});
module.exports = __toCommonJS(isStateAwaitingNavigatorMount_exports);
function _type_of(obj) {
  "@swc/helpers - typeof";
  return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function focusedRouteOf(state) {
  return typeof state.index === "number" ? state.routes[state.index] : state.routes[state.routes.length - 1];
}
function isStateAwaitingNavigatorMount(state, rootNode) {
  var _loop = function() {
    var route = focusedRouteOf(current);
    if (!route) return {
      v: false
    };
    var child = node.children.find(function(candidate) {
      return candidate.route === route.name;
    });
    if (!child) return {
      v: false
    };
    if (route.state) {
      node = child;
      current = route.state;
      return "continue";
    }
    return {
      v: child.children.some(function(grandchild) {
        return !grandchild.internal;
      })
    };
  };
  var _current_routes;
  if (!rootNode) return false;
  var node = rootNode;
  var current = state;
  while (current === null || current === void 0 ? void 0 : (_current_routes = current.routes) === null || _current_routes === void 0 ? void 0 : _current_routes.length) {
    var _ret = _loop();
    if (_type_of(_ret) === "object") return _ret.v;
  }
  return false;
}
//# sourceMappingURL=isStateAwaitingNavigatorMount.js.map
